// eslint-disable-next-line import/no-anonymous-default-export
export default {
  MH: {},
  RJ: {},
  UP: {},
  MP: {},
  GJ: {},
  BH: {},
};
